import React from 'react';


const Notfound = () => {

    return (
        <div>Not Found 404</div>
    );
};

export default Notfound;
